/**
 * Created by matheusmorett on 17/05/18.
 */
import Button from './Button.js';
export default Button;